export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-background-950 rounded-3xl overflow-hidden relative">
            <div className="absolute inset-0 opacity-20">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20abstract%20soft%20golden%20light%20particles%20floating%2C%20elegant%20gradient%20background%2C%20luxurious%20dark%20amber%20texture%2C%20no%20text%2C%20no%20people%2C%20premium%20film%20aesthetic&width=1200&height=500&seq=app-bg-mushroom&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
              />
            </div>

            <div className="relative px-6 md:px-12 py-12 md:py-16 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
                  随时随地看高清
                </h2>
                <p className="text-sm md:text-base text-background-300 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                  蘑菇影院移动端适配完美，手机平板都能流畅观看高清电影在线和电视剧全集。无需下载APP，浏览器打开即可畅享高清观影体验。
                </p>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                  {['高清画质', '流畅播放', '免下载', '全平台支持'].map((feat, i) => (
                    <span key={i} className="flex items-center gap-1.5 text-xs text-background-200">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                      {feat}
                    </span>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap text-center cursor-pointer"
                  >
                    <i className="ri-smartphone-line mr-1.5"></i>
                    手机端体验
                  </a>
                  <a
                    href="#faq"
                    className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold border border-background-400/40 text-background-200 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap text-center cursor-pointer"
                  >
                    了解更多
                  </a>
                </div>
              </div>

              <div className="w-48 md:w-56 lg:w-64 flex-shrink-0">
                <div className="relative mx-auto w-40 md:w-48 aspect-[9/16] rounded-2xl overflow-hidden border-2 border-background-700/50 shadow-2xl">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20mockup%20showing%20cinematic%20movie%20streaming%20interface%20with%20dark%20theme%2C%20warm%20golden%20accents%2C%20film%20poster%20thumbnails%2C%20elegant%20dark%20UI%2C%20modern%20app%20design%2C%20no%20text%20characters%2C%20abstract%20visual%20composition&width=480&height=854&seq=app-phone-mushroom&orientation=portrait"
                    alt="蘑菇影院移动端体验"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}